import { useQuery } from "@tanstack/react-query";
import { BRIEF_LEDGER_AGGREGATION_QUERY_KEY } from "../constants";
import { BriefService } from "../services/brief.service";

export function useGetBriefLedgerAggregation(briefId: string) {
  const { data, isFetching } = useQuery({
    queryKey: [...BRIEF_LEDGER_AGGREGATION_QUERY_KEY, briefId],
    queryFn: () => BriefService.getBriefLedgerAggregation(briefId),
  });

  return {
    aggregation: data?.data,
    isFetching,
  };
}
